import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";
import { LEGAL } from "@/constants/legal";
import { openCookiePreferences } from "@/components/landing/CookieConsent";

export default function CookiePolicy() {
  return (
    <LegalLayout overline="Informativa sui cookie" title="Cookie Policy">
      <p className="lead">
        La presente Cookie Policy è redatta ai sensi del Provvedimento del Garante per la Protezione dei Dati Personali n. 231 del 10 giugno 2021 e in conformità con il Regolamento UE 2016/679 (GDPR).
      </p>

      <h2>1. Cosa sono i cookie</h2>
      <p>
        I cookie sono piccoli file di testo inviati dal sito al browser
        dell'utente, dove vengono memorizzati per essere ritrasmessi al sito
        alla visita successiva. Possono essere di sessione (cancellati alla
        chiusura del browser) o persistenti (conservati fino a una data di
        scadenza).
      </p>

      <h2>2. Categorie di cookie utilizzati</h2>

      <h3>2.1 Cookie tecnici (sempre attivi)</h3>
      <p>
        Indispensabili per il funzionamento del sito. Non richiedono consenso
        ai sensi dell'art. 122 del Codice Privacy.
      </p>
      <table>
        <thead>
          <tr>
            <th>Cookie</th>
            <th>Finalità</th>
            <th>Durata</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><code>mdm-cookie-consent</code></td>
            <td>Memorizza le tue preferenze sui cookie</td>
            <td>Persistente (12 mesi)</td>
          </tr>
          <tr>
            <td><code>mdm-exit-intent-shown</code></td>
            <td>Evita di mostrarti più volte lo stesso popup</td>
            <td>Sessione</td>
          </tr>
        </tbody>
      </table>

      <h3>2.2 Cookie di statistica (consenso richiesto)</h3>
      <p>
        Utilizzati per raccogliere informazioni sull'utilizzo del sito in forma
        aggregata e anonima.
      </p>
      <table>
        <thead>
          <tr>
            <th>Servizio</th>
            <th>Fornitore</th>
            <th>Finalità</th>
            <th>Trasferimento dati</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>PostHog Analytics</td>
            <td>
              PostHog Inc. — 2261 Market Street, San Francisco, CA 94114, USA
            </td>
            <td>Statistiche di utilizzo, percorsi di navigazione, eventi anonimi</td>
            <td>USA (Clausole Contrattuali Standard)</td>
          </tr>
        </tbody>
      </table>
      <p>
        Privacy Policy PostHog:{" "}
        <a
          href="https://posthog.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          posthog.com/privacy
        </a>
      </p>

      <h3>2.3 Cookie di preferenze (consenso richiesto)</h3>
      <p>
        Salvano le tue preferenze di lettura (es. ultima sezione visualizzata,
        traccia audio in ascolto).
      </p>

      <h3>2.4 Cookie di marketing (consenso richiesto)</h3>
      <p>
        Utilizzati per misurare l'efficacia delle nostre campagne pubblicitarie
        e attribuire le conversioni.
      </p>
      <table>
        <thead>
          <tr>
            <th>Servizio</th>
            <th>Fornitore</th>
            <th>Finalità</th>
            <th>Trasferimento dati</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Google Ads (gtag.js)</td>
            <td>
              Google Ireland Limited / Google LLC — USA
            </td>
            <td>
              Misurazione conversioni delle campagne Google Ads, tracking
              eventi di acquisto. Operiamo in Google Consent Mode v2: senza
              consenso non vengono trasmessi dati identificativi.
            </td>
            <td>USA (EU-US Data Privacy Framework + SCC)</td>
          </tr>
        </tbody>
      </table>
      <p>
        Privacy Policy Google:{" "}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          policies.google.com/privacy
        </a>
      </p>

      <h2>3. Servizi di terze parti</h2>
      <p>Il sito si integra con i seguenti servizi che possono rilasciare cookie tecnici di terza parte:</p>
      <ul>
        <li>
          <strong>Stripe</strong> (gestione pagamenti) — usato solo durante il
          checkout.{" "}
          <a
            href="https://stripe.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </li>
        <li>
          <strong>Google Calendar</strong> (prenotazione consulenze) — usato
          solo cliccando il link di prenotazione.{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </li>
        <li>
          <strong>Amazon</strong> (link di acquisto) — il dominio amazon.it
          gestisce in autonomia i propri cookie.{" "}
          <a
            href="https://www.amazon.it/gp/help/customer/display.html?nodeId=201909010"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </li>
      </ul>

      <h2>4. Come gestire i cookie</h2>
      <p>
        Al primo accesso ti viene mostrato un banner per esprimere il consenso.
        Puoi modificare le tue scelte in qualsiasi momento cliccando il
        pulsante qui sotto, oppure puoi bloccare/cancellare i cookie tramite le
        impostazioni del tuo browser.
      </p>
      <p>
        <button
          onClick={openCookiePreferences}
          data-testid="cookie-policy-reopen"
          className="inline-block mt-3 px-6 py-3 bg-[#0B192C] text-[#F9F8F6] text-xs uppercase tracking-[0.18em] hover:bg-[#1E3557] transition-colors"
        >
          Modifica preferenze cookie
        </button>
      </p>

      <h2>5. Diritti dell'interessato</h2>
      <p>
        Per esercitare i tuoi diritti relativi ai cookie e ai dati personali,
        consulta la nostra{" "}
        <a href="/privacy">Privacy Policy</a> e contattaci all'indirizzo{" "}
        <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>.
      </p>

      <p className="mt-12 text-sm text-[#3A4F6B]">
        Ultimo aggiornamento: {LEGAL.lastUpdated}.
      </p>
    </LegalLayout>
  );
}
